// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const connectionsClient = createTypedClient();
export const createConnectionsClient = (config) => createTypedClient(config);
